export default state => {
	if (state.claims) {
		return Object.values(state.claims).sort((a, b) => {
			return (b && b.getTime ? b.getTime() : 0) - (a && a.getTime ? a.getTime() : 0);
		})[0];
	} else {
		return {};
	}
};
